import { empty } from 'ant-design-vue-admin-x';
export default {
  data () {
    return {
      selectedCsId: '',
      selectedCityId: '',
      formList: [
        {
          label: '城市',
          inputType: 'cascader',
          options: [],
          handle: e => {
            // 城市修改后，系统名称、设备类型、设备编码对应修改
            this.$refs.addEdit.resetSubValue(['csId', 'deviceCode']);
            this.$refs.addEdit.form.resetFields(['deviceType']);
            this.cityChange(e, 1);
          },
          placeholder: '请选择城市',
          props: ['areasList', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          label: '系统名称',
          inputType: 'select',
          options: [],
          handle: e => {
            this.selectedCsId = e;
            // 修改系统名称，设备类型、设备编码清空
            this.$refs.addEdit.resetSubValue(['deviceCode']);
            this.$refs.addEdit.form.resetFields(['deviceType']);
          },
          placeholder: '请选择系统名称',
          props: ['csId', {
            rules: [{required: true, message: '请选择系统名称'}]
          }]
        },
        {
          label: '采集设备信息标识',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入采集设备信息标识',
          props: ['deviceMark', {
            rules: [
              {required: true, message: '请输入采集设备信息标识'},
              {min: 1, max: 46, message: '设备信息标识长度为1-46位'}
            ]
          }]
        },
        {
          label: '国标ID',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入国标ID',
          props: ['nationalId', {
            rules: [
              {required: true, message: '请输入国标ID'},
              {min: 1, max: 50, message: '国标ID长度为1-50位'}
            ]
          }]
        },
        {
          label: '设备类型',
          inputType: 'select',
          options: [],
          handle: this.deviceTypeChange,
          placeholder: '请选择设备类型',
          props: ['deviceType', {
            rules: [{required: true, message: '请选择设备类型'}]
          }]
        },
        {
          label: '设备编码',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入设备编码',
          props: ['deviceCode', {
            rules: [
              {required: true, message: '请输入设备编码'},
              {min: 1, max: 50, message: '设备编码长度为1-50位'}
            ]
          }]
        },
        {
          label: '设备名称',
          inputType: 'input',
          options: [],
          handle: '',
          isShow: false,
          placeholder: '请输入设备名称',
          props: ['deviceName', {
            rules: [
              {required: true, message: '请输入设备名称'},
              {min: 1, max: 50, message: '设备名称长度为1-50位'}
            ]
          }]
        }
      ],
      formKey: {
        areasList: undefined,
        csId: undefined,
        deviceMark: undefined,
        nationalId: undefined,
        deviceType: undefined,
        deviceCode: undefined,
        deviceName: undefined
      },
      addParam: {
        url: '/coll/device/add',
        reqHandle: this.reqHandle, // addParam、editParaM都会执行 reqHandle方法
        resHandle: () => this.addResHandle('add')
      },
      editParam: {
        url: '/coll/device/edit/',
        resHandle: () => this.addResHandle('edit')
      },
      detailParam: {
        url: '',
        resHandle: '' // this.detailResHandle
      }
    };
  },
  created () {
  },
  methods: {
    /** 城市 change 事件 */
    cityChange (cityId, index) {
      let id = cityId && cityId.length ? Number(cityId[1]) : undefined;
      if (!id) { return false; }

      this.belongSystemName(id, index);
    },
    /** 获取系统名称下拉 */
    belongSystemName (id, index) {
      this.$get({
        url: '/coll/device/getAddCollSystem',
        params: { cityId: id }
      }).then(({ data }) => {
        this.formList[index].options = data;
      });
    },
    /** 设备编码下拉 */
    deviceCodeSelect () {
      console.log('csId: ', this.selectedCsId);
      this.selectedCsId && this.$get({
        url: '/coll/device/getCommunityDevice',
        params: { csId: this.selectedCsId }
      }).then(({ data }) => {
        this.formList[5].options = data;
      });
    },
    /** 设备类型 change 事件 */
    deviceTypeChange (e, type, values) {
      let deviceCode = this.formList[5];
      let item = this.formList[6];
      e !== 1 ? deviceCode.inputType = 'input' : deviceCode.inputType = 'select';
      e !== 1 ? item.isShow = true : item.isShow = false;
      e === 1 && this.deviceCodeSelect();

      this.$nextTick(() => {
        // 修改设备类型，设备编码、设备名称清空
        type !== 'edit' && this.$refs.addEdit.resetSubValue(['deviceName', 'deviceCode']);
        this.$refs.addEdit.form.setFieldsValue(values);
      });
    },
    openModal () {
      this.modalTitle = '新增采集设备';
      this.formList[0].options = this.cityList;
      this.formList[4].options = this.deviceTypeList;
      this.visible = true;
    },
    toEdit (row) {
      this.selectedCsId = row.csId;
      this.selectedCityId = row.cityId;
      this.modalTitle = '编辑采集设备';
      this.formList[0].options = this.cityList;
      this.formList[4].options = this.deviceTypeList;
      this.belongSystemName(row.cityId, 1);
      let values = {};
      for (let item in row) {
        if (this.formKey.hasOwnProperty(item)) {
          values[item] = row[item];
        }
      }
      this.visible = true;
      this.deviceTypeChange(row.deviceType, 'edit', values);

      this.$nextTick(() => {
        this.$refs.addEdit.routeQuery = row.cdId;
      });
    },
    detailResHandle (res) {
      return res;
    },
    reqHandle (param) {
      param.cityId = this.selectedCityId;
      return param;
    },
    addResHandle (type) {
      this.$message.success(type === 'add' ? '新增成功' : '编辑成功');
      this.visible = false;
      this.getSystemName(undefined, 1);
      this.$refs.table.getTableList();
    }
  }
};
